// LucideIcon.jsx
import * as Icons from 'lucide-react';

const SocondLucide = ({
  name,
  fill = '#4361ee', // the inner fill color
  stroke = '#4361ee',   // the border color
  size = 24,
  style = {},
  ...props
}) => {
  const IconComponent = Icons[name];

  if (!IconComponent) {
    return <span>Invalid icon: {name}</span>;
  }

  return (
    <IconComponent
      size={size}
      stroke={stroke}
      fill={fill}
      style={{ ...style }}
      {...props}
    />
  );
};

export default SocondLucide;
